import {map, share} from 'rxjs/operators';
import {of, Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {ApiService} from './api';

@Injectable({providedIn: 'root'})
export class EquipmentClassService {
  path: string = '/api';
  equipmentClasses: any = null;
  partnerId: number | null = null;
  constructor(private apiService: ApiService) {}

  private observable: Observable<any> | null = null;

  getEquipmentClasses(partnerId: number) {
    if (partnerId === this.partnerId && this.equipmentClasses) {
      return of(this.equipmentClasses);
    } else if (this.observable) {
      return this.observable;
    } else {
        this.observable = this.apiService.get(`${this.path}/v2/airlines/${partnerId}/aircraft_subfleets`).pipe(
        map((response: any) => {
          this.observable = null;
          this.partnerId = partnerId;
          this.equipmentClasses = response;
          return this.equipmentClasses;
        }),
        share(),
      );
      return this.observable;
    }
  }
}
